<div class="space-y-4">
  <!-- Header with masked identifier -->
  <div class="opacity-80">
    @if (instructionText) {
    <p class="text-gray-700 text-sm mb-3">
      {{ instructionText }}
    </p>
    } @else {
    <p class="text-gray-700 text-sm mb-3">
      Hemos enviado un código de {{ length }} dígitos.
    </p>
    <p class="text-gray-700 text-sm mb-3">
      Escríbelo a continuación para continuar con el proceso.
    </p>
    }
  </div>

  @if (valueDisplay) {
  <p class="font-semibold text-md fs-condensed text-center">
    {{ valueDisplay }}
  </p>
  }

  <div
    class="flex justify-center space-x-2"
    role="group"
    aria-label="Código de verificación"
  >
    @for (digit of otpData.otpCode; track $index) {
    <input
      placeholder="_"
      type="text"
      maxlength="1"
      [value]="digit"
      [disabled]="isLoading"
      (input)="onOtpInput($event, $index)"
      (keydown)="onOtpKeydown($event, $index)"
      class="w-12 h-12 text-center text-base font-semibold border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-appPrimary-500 focus:border-transparent"
      [class.border-appPrimary-500]="digit !== ''"
      [attr.aria-label]="'Dígito ' + ($index + 1) + ' del código OTP'"
    />
    }
  </div>

  <!-- Error Message -->
  @if (otpData.hasError) {
  <div class="text-center mb-3" role="alert">
    <p class="text-red-500 text-xs font-medium">{{ otpData.errorMessage }}</p>
  </div>
  }

  <!-- Primary Action Button -->
  <button
    type="button"
    [class]="getButtonClass()"
    [disabled]="isButtonDisabled"
    (click)="verify()"
    aria-describedby="primary-button-help"
  >
    @if (isLoading) {
    <span class="flex items-center justify-center">
      <app-loading-spinner size="sm"></app-loading-spinner>
      Verificando...
    </span>
    } @else {
    <span>{{ submitLabel }}</span>
    }
  </button>

  <p class="text-gray-700 text-sm mb-3">{{ bottomText }}</p>
  <ng-content select="[slot=bottom-text]"></ng-content>

  <!-- Action Links -->
  @if (withResendButton) {
  <div class="flex justify-center space-x-3 text-sm">
    @if (!canResendCode) {
    <span class="text-gray-500"> Reenviar en {{ otpData.countdown }}s </span>
    } @else {
    <button
      type="button"
      class="text-appPrimary-500 hover:text-appPrimary-600 transition-colors"
      (click)="resendCode()"
      aria-label="Reenviar código"
    >
      Reenviar código
    </button>
    }
  </div>
  }
</div>
